var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocalPolice = function SvgLocalPolice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.566 15.1 12 13.25l2.384 1.831-.915-2.957 2.473-1.931h-2.977L12 7.216l-.965 2.977H8.058l2.423 1.93zM12 21.482q-3.244-.885-5.372-3.819T4.5 11.101V5.347L12 2.539l7.5 2.808V11.1q0 3.627-2.128 6.561T12 21.482"
  })));
};
export default SvgLocalPolice;